module.exports = __webpack_public_path__ + "img/footer-logo.6b532a45.png";